module.exports = __webpack_public_path__ + "app/bento-components/video-list/media/disabledIcon.svg?2ff33d8dd75d4d5b700cc7c42aebbac0";